var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "portfolio container" }, [
    _c("h2", { staticClass: "portfolio__header" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "portfolio__filters" },
      _vm._l(_vm.categories, function(category) {
        return _c(
          "li",
          {
            staticClass: "portfolio__filter",
            class: {
              "portfolio__filter--active": _vm.isCurrentCategory(category.slug)
            },
            on: {
              click: function($event) {
                return _vm.setCategory(category.slug)
              }
            }
          },
          [_vm._v(_vm._s(category.title))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "portfolio__entries row" },
      _vm._l(_vm.portfolio, function(entry, index) {
        return _c(
          "div",
          {
            staticClass: "portfolio__entry col-12 col-sm-6 col-xl-4",
            class: {
              "portfolio__entry--active": _vm.containsCategory(
                entry.categories,
                entry.text
              )
            }
          },
          [
            !entry.text
              ? _c(
                  "a",
                  {
                    staticClass: "portfolio__permalink",
                    attrs: { href: entry.permalink }
                  },
                  [
                    _c("lazy-image", {
                      staticClass: "portfolio__image",
                      attrs: {
                        src: entry.thumbnail,
                        contain: false,
                        srcSmall: entry.lazy
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "portfolio__description" }, [
                      _c("div", { staticClass: "portfolio__meta" }, [
                        _c("h4", { staticClass: "portfolio__tag" }, [
                          _vm._v(_vm._s(entry.tags))
                        ]),
                        _vm._v(" "),
                        _c("h3", { staticClass: "portfolio__title" }, [
                          _vm._v(_vm._s(entry.title))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "portfolio__watermark" }),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "portfolio__categories" },
                        _vm._l(entry.categories, function(category) {
                          return _c(
                            "li",
                            { staticClass: "portfolio__category" },
                            [_vm._v(_vm._s(category.name))]
                          )
                        }),
                        0
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            entry.text
              ? _c(
                  "div",
                  {
                    staticClass:
                      "portfolio__permalink portfolio__permalink--text"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "portfolio__permalink-text-content" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(entry.text) +
                            "\n                "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ec34acf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec34acf","hasScoped":false,"buble":{"transforms":{}}}!/Users/fabianschneider/Documents/Development/code/wordpress/lineabertoli/web/app/themes/lineabertoli/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/vue/archive-portfolio.vue
// module id = 27
// module chunks = 0